var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOttoPeekSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 745,
    viewBox: "0 0 740 745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.437 332.926C421.437 117.745 409.12 241.366 257.186 328.038L269.686 607.9C383.247 585.363 421.437 506.396 421.437 332.926Z",
    fill: "url(#paint0_linear_1381_66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.339 234.029C391.559 250.443 378.8 242.521 344.886 261.664C308.999 281.921 301.885 272.651 287.72 277.188C273.556 281.724 291.212 221.759 345.757 208.387C380.773 199.803 415.119 217.615 403.339 234.029Z",
    fill: "#C4AC5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.807 280.717C487.615 300.242 501.84 305.063 508.601 343.414C515.757 383.999 527.435 383.603 532.93 397.424C538.425 411.245 573.518 359.514 549.192 308.895C533.576 276.4 497.999 261.192 492.807 280.717Z",
    fill: "#C4AC5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M464.481 221.851C620.8 283.31 434.992 454.614 417.739 467.921C400.486 481.228 302.522 434.964 302.573 411.389C302.624 387.813 309.389 137.096 464.481 221.851Z",
    fill: "url(#paint1_linear_1381_66)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1381_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.108 418.876C369.108 418.876 400.9 411.834 384.59 444.593C372.839 468.196 354.347 479.605 341.669 473.293C328.991 466.98 326.926 445.337 338.678 421.734C354.181 390.596 369.108 418.876 369.108 418.876Z",
    fill: "url(#paint2_linear_1381_66)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.201 419.641C369.201 419.641 403.349 474.919 423.176 433.748C437.461 404.083 425.749 372.864 398.936 359.952C372.123 347.04 340.364 357.324 326.078 386.989C307.232 426.124 369.201 419.641 369.201 419.641Z",
    fill: "#C2AA5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.184 370.753C365.453 378.452 369.152 394.11 380.071 399.402C390.99 404.694 404.994 397.615 408.725 389.916C412.456 382.217 404.603 375.868 393.684 370.576C382.765 365.284 372.915 363.054 369.184 370.753Z",
    fill: "#3D3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M436.62 346.257C432.529 353.574 443.635 350.178 452.289 355.016C460.942 359.854 463.867 371.092 467.958 363.775C472.048 356.458 466.127 350.579 457.473 345.742C448.819 340.904 440.71 338.94 436.62 346.257Z",
    fill: "#3D3D3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.415 321.603C381.363 329.411 376.93 318.677 367.697 315.067C358.463 311.458 347.926 316.339 350.978 308.531C354.03 300.724 362.331 301.562 371.565 305.172C380.799 308.781 387.468 313.796 384.415 321.603Z",
    fill: "#3D3D3D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.247 202.592C393.56 223.797 364.52 220.392 330.607 239.535C294.719 259.792 293.495 291.258 279.33 295.794C265.166 300.331 283.567 205.455 335.948 185.202C396.671 161.723 402.935 181.388 398.247 202.592Z",
    fill: "#D6C68F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M520.319 264.677C506.922 281.768 528 302.031 534.762 340.383C541.917 380.967 518.395 401.902 523.891 415.723C529.386 429.544 590.965 355.06 573.328 301.74C552.883 239.93 533.717 247.586 520.319 264.677Z",
    fill: "#D6C58F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1381_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.865 313.257C279.831 311.345 308.573 328.173 311.285 350.816C313.997 373.458 289.652 393.34 273.687 395.252C257.721 397.165 258.905 376.182 256.193 353.539C253.48 330.897 247.9 315.169 263.865 313.257Z",
    fill: "#D3C188"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1381_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.736 629.672C299.118 628.565 324.767 606.234 323.198 583.001C321.629 559.769 293.435 544.434 277.053 545.54C260.671 546.647 267.002 566.817 268.572 590.049C270.141 613.281 266.355 630.778 282.736 629.672Z",
    fill: "#D3C188"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1381_66",
    x: 325.615,
    y: 407.113,
    width: 68.93,
    height: 80.1987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1381_66",
    x: 249.002,
    y: 306.109,
    width: 78.4914,
    height: 102.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1381_66",
    x: 262.056,
    y: 538.484,
    width: 77.2109,
    height: 104.237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1381_66",
    x1: 341.186,
    y1: 305.689,
    x2: 279.686,
    y2: 486.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1A857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0BE80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1381_66",
    x1: 420.728,
    y1: 212.508,
    x2: 401.637,
    y2: 467.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6C690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1A959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1381_66",
    x1: 341.657,
    y1: 473.287,
    x2: 371.363,
    y2: 413.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoPeekSide);
export default __webpack_public_path__ + "static/media/otto-peek-side.a80da70c781ab8434d99fd8f8911743b.svg";
export { ForwardRef as ReactComponent };